import React from "react";

// CSS filter values for different colors
const COLOR_FILTERS = {
  white: "none", // Original SVG is white
  orange: "brightness(0) saturate(100%) invert(57%) sepia(98%) saturate(1704%) hue-rotate(360deg) brightness(103%) contrast(106%)",
  black: "brightness(0)",
  primary: "brightness(0) saturate(100%) invert(15%) sepia(95%) saturate(6932%) hue-rotate(246deg) brightness(93%) contrast(103%)",
} as const;

type ColorOption = keyof typeof COLOR_FILTERS;

interface InkedLogoProps {
  color?: ColorOption;
  className?: string;
}

export const InkedLogo: React.FC<InkedLogoProps> = ({
  color = "primary",
  className = "h-5",
}) => {
  const filter = COLOR_FILTERS[color];

  return (
    <img
      src="/images/inked-logo.svg"
      alt="Inked"
      className={className}
      style={filter !== "none" ? { filter } : undefined}
    />
  );
};

export default InkedLogo;
